export const DEFAULT = "default"
export const HOLLOW = "hollow"
export const BORDER_LESS = "borderless"
